import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import HowItWorks from "@/components/landing/HowItWorks";
import Services from "@/components/landing/Services";
import Trust from "@/components/landing/Trust";
import ForCustomers from "@/components/landing/ForCustomers";
import ForTaskers from "@/components/landing/ForTaskers";
import AppSection from "@/components/landing/AppSection";
import Reviews from "@/components/landing/Reviews";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import London from "@/pages/London";
import BoroughPage from "@/pages/BoroughPage";
import OgCard from "@/pages/OgCard";
import { Terms, Privacy, Cookies, Complaints } from "@/pages/Legal";

function Landing() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <HowItWorks />
        <Services />
        <Trust />
        <ForCustomers />
        <ForTaskers />
        <AppSection />
        <Reviews />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href");
      if (id.length > 1 && document.querySelector(id)) {
        e.preventDefault();
        lenis.scrollTo(id, { offset: -72 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="grain font-body bg-paper text-charcoal" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/london" element={<London />} />
          <Route path="/london/camden" element={<BoroughPage borough="camden" />} />
          <Route path="/london/islington" element={<BoroughPage borough="islington" />} />
          <Route path="/london/hackney" element={<BoroughPage borough="hackney" />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/complaints" element={<Complaints />} />
          <Route path="/og-card" element={<OgCard />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
